module.exports = __webpack_public_path__ + "static/media/kmv.ef0e3a3e.png";